// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  refId: __t.u64().primaryKey().name("ref_id"),
  fileId: __t.u64().name("file_id"),
  chunkIndex: __t.u32().name("chunk_index"),
  chunkHash: __t.string().name("chunk_hash"),
});
